module.exports = __webpack_public_path__ + "media/images/legal-aead7d5384392041641b9a987982f2e5.png";